import './view.scss';

const DURATION_MS = 260;

const initAccordion = (root) => {
    const allowMultiple = root.dataset.allowMultiple === '1';
    const triggers = Array.from(root.querySelectorAll('.accordion__trigger'));

    const getPanel = (trigger) => {
        const id = trigger.getAttribute('aria-controls');
        if (!id) return null;
        return root.querySelector('#' + CSS.escape(id));
    };

    const setOpen = (trigger, open) => {
        const panel = getPanel(trigger);
        if (!panel) return;

        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (open) {
            panel.removeAttribute('hidden');
            panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
            panel.style.maxHeight = '0px';
            window.setTimeout(() => {
                if (trigger.getAttribute('aria-expanded') === 'false') {
                    panel.setAttribute('hidden', '');
                }
            }, DURATION_MS);
        }
    };

    const closeOthers = (except) => {
        if (allowMultiple) return;
        triggers.forEach((t) => {
            if (t === except) return;
            setOpen(t, false);
        });
    };

    const toggle = (trigger) => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (!isOpen) closeOthers(trigger);
        setOpen(trigger, !isOpen);
    };

    const syncInitialState = () => {
        triggers.forEach((trigger) => {
            const panel = getPanel(trigger);
            if (!panel) return;

            const expanded = trigger.getAttribute('aria-expanded') === 'true';
            panel.removeAttribute('hidden');

            if (expanded) {
                panel.style.maxHeight = panel.scrollHeight + 'px';
            } else {
                panel.style.maxHeight = '0px';
                panel.setAttribute('hidden', '');
            }
        });
    };

    const bind = () => {
        triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => toggle(trigger));

            trigger.addEventListener('keydown', (event) => {
                const key = event.key;

                if (key === 'Enter' || key === ' ') {
                    event.preventDefault();
                    toggle(trigger);
                    return;
                }

                if (key === 'ArrowDown') {
                    event.preventDefault();
                    const next = Math.min(index + 1, triggers.length - 1);
                    triggers[next].focus();
                    return;
                }

                if (key === 'ArrowUp') {
                    event.preventDefault();
                    const prev = Math.max(index - 1, 0);
                    triggers[prev].focus();
                    return;
                }

                if (key === 'Home') {
                    event.preventDefault();
                    triggers[0].focus();
                    return;
                }

                if (key === 'End') {
                    event.preventDefault();
                    triggers[triggers.length - 1].focus();
                }
            });
        });
    };

    syncInitialState();
    bind();

    window.addEventListener('resize', () => {
        triggers.forEach((trigger) => {
            if (trigger.getAttribute('aria-expanded') !== 'true') return;
            const panel = getPanel(trigger);
            if (!panel) return;
            panel.style.maxHeight = panel.scrollHeight + 'px';
        });
    });
};

const initAll = () => {
    document.querySelectorAll('.accordion').forEach((root) => {
        if (root.dataset.accordionInit === '1') return;
        root.dataset.accordionInit = '1';
        initAccordion(root);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}